module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark-4396cac23f13b8d21da322a982a61215.png";